import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import withGlobalData from 'components/providers/global-data';

import SmartLogo from 'static/smart-logo.png';
import { TabBar, TabBarItem } from 'components/common/tab-bar';
import Typography from 'components/common/typography';

import {
  MainLayoutContainer,
  MainLayoutCard,
  MainLayoutHeader,
  MainLayoutContent,
  LogoContainer,
  LogoImage,
  TextContainer,
  Row,
} from './elements';

const logout = () => {
  localStorage.removeItem('userInventoryToken');
  localStorage.removeItem('userInventory');
  window.location.reload();
};

const Menu = withRouter(({ user, location: { pathname } }) => {
  let role = '';

  if (user) {
    role = user.role;
  }

  const showUsers = ['SUPER_ADMIN'].includes(role);
  const showCreateReport = ['SUPER_ADMIN'].includes(role);
  const showEditReport = ['SUPER_ADMIN'].includes(role);
  const showLocationCount = ['SUPER_ADMIN', 'ADMIN', 'COUNTER'].includes(role);
  const showLocationStatus = ['SUPER_ADMIN', 'ADMIN', 'AUDITOR'].includes(role);
  const showReports = ['SUPER_ADMIN', 'ADMIN', 'AUDITOR'].includes(role);

  return (
    <TabBar>
      {showUsers && (
        <TabBarItem to="/usuarios" location={pathname}>
          Usuarios
        </TabBarItem>
      )}
      {showCreateReport && (
        <TabBarItem to="/crear-ubicacion" location={pathname}>
          Crear nueva ubicacion
        </TabBarItem>
      )}
      {showCreateReport && (
        <TabBarItem to="/crear-inventario" location={pathname}>
          Crear nuevo inventario
        </TabBarItem>
      )}
      {showEditReport && (
        <TabBarItem to="/modificar-inventario" location={pathname}>
          Modificar inventario
        </TabBarItem>
      )}
      {showLocationCount && (
        <TabBarItem to="/conteo-ubicacion" location={pathname}>
          Nuevo conteo por ubicación
        </TabBarItem>
      )}
      {showLocationStatus && (
        <TabBarItem to="/estatus-ubicaciones" location={pathname}>
          Estatus de ubicaciones
        </TabBarItem>
      )}
      {showReports && (
        <TabBarItem to="/reportes" location={pathname}>
          Reportes
        </TabBarItem>
      )}
    </TabBar>
  );
});

const MainLayout = ({ children, user, flexColumn }) => (
  <MainLayoutContainer>
    <MainLayoutCard>
      <MainLayoutHeader>
        <LogoContainer>
          <LogoImage src={SmartLogo} />
        </LogoContainer>
        <TextContainer>
          <Typography sm>Hola! {user && user.name}</Typography>
          <Row>
            <Typography fontSize="12" marginR="20">
              {user && user.role.toUpperCase()}
            </Typography>
            <Typography fontSize="12" clickable primary onClick={logout}>
              Cerrar sesión
            </Typography>
          </Row>
        </TextContainer>
      </MainLayoutHeader>
      <MainLayoutContent flexColumn={flexColumn}>
        <Menu user={user} />
        {children}
      </MainLayoutContent>
    </MainLayoutCard>
  </MainLayoutContainer>
);

MainLayout.defaultProps = {
  flexColumn: false,
  user: {},
};

MainLayout.propTypes = {
  children: PropTypes.any.isRequired,
  flexColumn: PropTypes.bool,
  user: PropTypes.shape(),
};

export default withGlobalData(MainLayout);
